// extracted by mini-css-extract-plugin
export default {"openDataWrap":"openDetail_openDataWrap__Syr2W","bannerWrap":"openDetail_bannerWrap__IRohF","bannerContent":"openDetail_bannerContent__W0Blu"};